import SSHeadline from "@core-components/title/SSHeadline";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { SimpleGrid, Stack } from "@mantine/core";
import { useMemo } from "react";
import type IChampion from "../../shared/models/IChampion.model";
import ChampionAvatarCard from "./ChampionAvatarCard";
import Search from "./SkinSearch";

interface SkinSearchGridProps {
  search: string;
  setSearch: (value: string) => void;
  filteredChampionsAndSkins: IChampion[];
  scrollRef: React.RefObject<HTMLInputElement | null>;
}

export const SkinSearchGrid = ({
  search,
  setSearch,
  filteredChampionsAndSkins,
  scrollRef,
}: SkinSearchGridProps) => {
  const { t } = useAppTranslation("pages.skins.search");

  const avatarNodes = useMemo(
    () =>
      filteredChampionsAndSkins.map((champion) => (
        <ChampionAvatarCard key={champion.slug} champion={champion} />
      )),
    [filteredChampionsAndSkins],
  );

  return (
    <>
      <Stack align="center" gap={30}>
        <SSHeadline>
          <SSWhiteText>{t("allSkins.title")}</SSWhiteText>
        </SSHeadline>

        <Search
          ref={scrollRef}
          maxSize="max-w-[400px]"
          value={search}
          values={filteredChampionsAndSkins}
          onChange={setSearch}
        />
      </Stack>

      {avatarNodes.length === 0 && (
        <SSHeadline
          props={{
            title: {
              className: "bg-primary-darker p-5 rounded-3xl",
              fz: 24,
            },
          }}
        >
          <SSWhiteText>{t("allSkins.empty")}</SSWhiteText>
        </SSHeadline>
      )}

      <SimpleGrid
        className="w-full max-w-[866px]"
        cols={{ base: 2, xs: 3, sm: 4 }}
        spacing={10}
        verticalSpacing={25}
      >
        {avatarNodes}
      </SimpleGrid>
    </>
  );
};
